import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { IconProps } from './types/IconProps';

export const CheckCircleRoundedIcon = (props: IconProps): ReactNode => (
  <Icon {...props} testId={locator.components.icon.checkCircleRounded}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.29 16.29 5.7 12.7a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0" />
  </Icon>
);
